/*
 * @Author: guoyu
 * @Date: 2021-04-23 15:26:45
 * @LastEditors: your name
 * @LastEditTime: 2021-04-26 19:01:33
 * @Description: file content
 */
import Fingerprint2 from 'fingerprintjs2';
// 设备唯一标示
let userFingerprint;
Fingerprint2.get({}, function(components) {
  var values = components.map(function(component) {
    return component.value;
  });
  userFingerprint = Fingerprint2.x64hash128(values.join(''), 31);
});
export default function getUserFingerprint() {
  return userFingerprint;
}
